import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=04c68ac4&scoped=true&"
import script from "./Balances.vue?vue&type=script&lang=js&"
export * from "./Balances.vue?vue&type=script&lang=js&"
import style0 from "./Balances.vue?vue&type=style&index=0&id=04c68ac4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c68ac4",
  null
  
)

export default component.exports